/**
 * @generated SignedSource<<29d10b38d856ac16524a4ccebd897d77>>
 * @relayHash 87b51f605ac895f07042f5fb06ccebf9
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-finding/536.0.0-2025-11-12T18:03:34.509Z/FindingSharedModifyPortfolioItemsMutation

import { ConcreteRequest } from 'relay-runtime';
export type PortfolioItemsAction = "ADD" | "EDIT" | "REMOVE" | "REORDER" | "%future added value";
export type PortfolioType = "CART" | "HEART" | "%future added value";
export type ModifyPortfolioItemsInput = {
  action: PortfolioItemsAction;
  clientMutationId?: string | null;
  endPortfolioItemId?: string | null;
  items?: ReadonlyArray<OfflineCartItem | null> | null;
  itemsIds?: ReadonlyArray<string | null> | null;
  note?: string | null;
  portfolioId?: string | null;
  portfolioItemsIds?: ReadonlyArray<string | null> | null;
  portfolioType?: PortfolioType | null;
  startPortfolioItemId?: string | null;
  targetPortfolioItemId?: string | null;
  userId: string;
};
export type OfflineCartItem = {
  itemId?: string | null;
  quantity?: number | null;
  skuId?: string | null;
};
export type FindingSharedModifyPortfolioItemsMutation$variables = {
  input: ModifyPortfolioItemsInput;
};
export type FindingSharedModifyPortfolioItemsMutation$data = {
  readonly modifyPortfolioItems: {
    readonly removedItemIds: ReadonlyArray<string | null> | null;
  } | null;
};
export type FindingSharedModifyPortfolioItemsMutation = {
  response: FindingSharedModifyPortfolioItemsMutation$data;
  variables: FindingSharedModifyPortfolioItemsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ModifyPortfolioItemsPayload",
    "kind": "LinkedField",
    "name": "modifyPortfolioItems",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "removedItemIds",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FindingSharedModifyPortfolioItemsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FindingSharedModifyPortfolioItemsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "app-buyer-finding/536.0.0-2025-11-12T18:03:34.509Z/FindingSharedModifyPortfolioItemsMutation",
    "metadata": {},
    "name": "FindingSharedModifyPortfolioItemsMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "3686fb0a0421042f6ec588dd6f81f363";

export default node;
